"use client";
import {
  tabs_default
} from "./chunk-H2JNJKGN.mjs";
import "./chunk-7ARJTFQR.mjs";
import "./chunk-BM6MJNZ5.mjs";
import {
  useTabs
} from "./chunk-BLIEYGZ2.mjs";
import {
  tab_item_base_default
} from "./chunk-ML27DD5T.mjs";
export {
  tab_item_base_default as Tab,
  tabs_default as Tabs,
  useTabs
};
